import { Interfaces } from "../_interfaces";

export function OnGridRowSelectionChanged(s: Interfaces.MVCxClientGridViewWithSelectedKeys, e) {
    let isNoPreselection: boolean = s.cpIsInit === undefined;
    let isNoInit: boolean = s.cpIsInit !== undefined && s.cpIsInit === false;

    if ((isNoPreselection || isNoInit) && !s.cpUnderRefresh) {
        if (e.visibleIndex > -1) {
            const key: string = s.GetRowKey(e.visibleIndex);

            OnGridRowSelection(s, e, key);
        }
    }

    s.cpIsInit = false;
    s.cpUnderRefresh = false;
}

export function OnGridRowSelection(grid: Interfaces.MVCxClientGridViewWithSelectedKeys, e, key: string) {
    if (e.isSelected && !grid.cpSelectedKeys.includes(key)) {
        grid.cpSelectedKeys.push(key);
    } else if (!e.isSelected && grid.cpSelectedKeys.includes(key)) {
        grid.cpSelectedKeys = grid.cpSelectedKeys.filter((val) => val !== key);
    }
}

export function OnHeaderCbCheckedChanged(s: Interfaces.MVCxClientGridViewWithSelectedKeys, e, gridName: string) {
    const grid: Interfaces.MVCxClientGridViewWithSelectedKeys = window[gridName] as Interfaces.MVCxClientGridViewWithSelectedKeys;

    if (s.GetChecked()) {
        grid.SelectAllRowsOnPage(true);
        grid.isCbSelectAllChecked = true;
        AddKeys();
    } else {
        grid.UnselectAllRowsOnPage();
        grid.isCbSelectAllChecked = false;
        RemoveKeys();
    }

    function AddKeys(): void {
        for (let key of GetAllKeys()) {
            if (!grid.cpSelectedKeys.includes(key)) {
                grid.cpSelectedKeys.push(key);
            }
        }
    }

    function RemoveKeys(): void {
        for (let key of GetAllKeys()) {
            if (grid.cpSelectedKeys.includes(key)) {
                grid.cpSelectedKeys = grid.cpSelectedKeys.filter((value) => value !== key);
            }
        }
    }

    function GetAllKeys(): string[] {
        let visibleIndices: number[] = grid.GetVisibleRowsIndicesForAdaptivity();
        let result: string[] = [];

        for (let visibleIndex of visibleIndices) {
            let rowKey: string = grid.GetRowKey(visibleIndex);
            result.push(rowKey);
        }

        return result;
    }
}
